import React, {useState} from 'react';
import {Dialog} from 'primereact/dialog';
import {useTranslation} from 'react-i18next';
import {InputTextarea} from '../../../../../Components/Input/Style';
import {InputWrapper} from 'src/Components/Input/Style';
import {HeaderWrapper} from "../../../../../HOC/Layout/Style";
import {MessageAlignLeft} from "../../LLMInteractionCategoriesEditor/Style";
import {Button} from "primereact/button";
import LlmInteractionCategoryDTO = API_ATRIA.Schemas.LlmInteractionCategoryDTO;

interface ModalCreateNewCategoriesProps {
    visible: boolean;
    onHide: () => void;
    addCategories: (categories: LlmInteractionCategoryDTO[]) => void;
    botUUID: string;
}

const ModalCreateNewCategories = ({
                                      visible,
                                      onHide,
                                      addCategories,
                                      botUUID,
                                  }: ModalCreateNewCategoriesProps) => {
    const [categoriesToCreate, setCategoriesToCreate] = useState<string>('');

    const {t} = useTranslation();

    const resetData = () => {
        setCategoriesToCreate('');
    }

    const renderHeaderModal = (
        <HeaderWrapper>
            <h1 className='p-panel-title'>{t('pages.llm-interaction-categories.modal.create-new-categories.title')}</h1>
        </HeaderWrapper>
    );

    const handleAddCategories = () => {
        const categories: LlmInteractionCategoryDTO[] = [];
        categoriesToCreate.split('\n').forEach((line) => {
            if (line.trim().length > 0) {
                const lineData = line.trim().split(':');
                categories.push({
                    botUUID: botUUID,
                    name: lineData[0]?.trim(),
                    description: lineData[1]?.trim()
                })
            }
        })

        addCategories(categories);
        resetData();
    }

    return (
        <Dialog
            visible={visible}
            onHide={() => {
                resetData();
                onHide();
            }}
            dismissableMask={true}
            blockScroll={true}
            header={renderHeaderModal}
            style={{
                width: '80%',
                fontSize: '1em',
            }}
        >
            <InputWrapper>
                <MessageAlignLeft
                    text={t('pages.llm-interaction-categories.modal.create-new-categories.multiple-add-title')}/>
                <InputTextarea value={categoriesToCreate} style={{height: '200px'}}
                               placeholder={t('pages.llm-interaction-categories.modal.create-new-categories.multiple-add-placeholder')}
                               onChange={(e) => setCategoriesToCreate(e.target.value)}/>
                <Button
                    style={{height: '40px', marginTop: '10px'}}
                    label={t('general.add')}
                    onClick={handleAddCategories}
                    className='p-button-primary'
                    icon='icon-add'
                />
            </InputWrapper>
        </Dialog>
    );
};

export default ModalCreateNewCategories;
